module.exports = __webpack_public_path__ + "media/audio21.d1e0a317.mp3";